import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 danielchen3. All rights reserved.</p>
    </footer>
  );
};

export default Footer;